const asArray = (value) => {
  if (Array.isArray(value)) return value;
  if (value && typeof value === "object") return Object.values(value);
  return [];
};

export const normalizeResourceItems = (resource = {}) => {
  const snake = asArray(resource.resource_items);
  const camel = asArray(resource.resourceItems);
  return snake.length > 0 || resource.resourceItems == null ? snake : camel;
};

export const normalizeResource = (resource = {}) => {
  const hasItems = resource && (Object.prototype.hasOwnProperty.call(resource, "resource_items") || Object.prototype.hasOwnProperty.call(resource, "resourceItems"));
  const hasServices = resource && (
    Object.prototype.hasOwnProperty.call(resource, "services")
    || Object.prototype.hasOwnProperty.call(resource, "assigned_services")
    || Object.prototype.hasOwnProperty.call(resource, "assignedServices")
  );
  const services = resource.services ?? resource.assigned_services ?? resource.assignedServices;
  return {
    ...resource,
    ...(hasItems ? { resource_items: normalizeResourceItems(resource) } : {}),
    ...(hasServices ? { services: asArray(services) } : {}),
  };
};

export const normalizeResourceListResponse = (response) => {
  if (Array.isArray(response)) {
    return {
      current_page: 1,
      data: response.map(normalizeResource),
      last_page: 1,
      next_page_url: null,
      per_page: response.length,
      prev_page_url: null,
      total: response.length,
    };
  }

  if (!response || typeof response !== "object") return response;

  const pagination = response.pagination || response.meta || {};
  const currentPage = Number(response.current_page ?? pagination.current_page ?? pagination.page ?? 1) || 1;
  const lastPage = Number(response.last_page ?? pagination.last_page ?? pagination.pages ?? currentPage) || currentPage;
  return {
    ...response,
    data: asArray(response.data).map(normalizeResource),
    current_page: currentPage,
    last_page: lastPage,
    next_page_url: response.next_page_url ?? pagination.next_page_url ?? (currentPage < lastPage ? `afterlogin/resource/view?page=${currentPage + 1}` : null),
  };
};

export const normalizeResourceDetailResponse = (response) => {
  if (!response || typeof response !== "object") return response;

  const resource = !Array.isArray(response.data) && response.data && typeof response.data === "object"
    && (response.resource_name == null && response.resource_items == null && response.resourceItems == null)
    ? response.data
    : response;

  return normalizeResource(resource);
};
